<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Grade Step</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="handleChildEvent"
              ></CampaignAutocomplete>
            </div>
            <span class="text-danger text-sm mt-3" v-show="campaign_required"
              >{{ campaign_required }}
            </span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="step_name"
                v-model="grade_steps.step_name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('step_name')"
              >{{ errors.first("step_name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                name="description"
                class="w-full"
                v-model="grade_steps.step_description"
                v-validate="'required'"
                data-vv-as="GradeStep"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Order:</span>
            </div>
            <div class="vx-col">
              <vs-input-number
                class="w-full"
                name="order_by"
                v-model="grade_steps.order_by"
                v-validate="'required'"
                data-vv-as="Order"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('order_by')"
              >{{ errors.first("order_by") }}</span
            >
          </div>

          <div class="vx-row mb-6" v-if="selected_campaign.length != 0">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Account Fields:</span>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Master Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in master_account_fields"
                :key="index"
              >



              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" grade_steps.master_account_field"
             
             
            />
            {{ v.name }}


              </div>

            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Campaign Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in campaign_account_fields"
                :key="index"
              >

              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" grade_steps.campaign_account_field"
             
             
            />
            {{ v.name }}


              
              </div>

            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Client Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in client_account_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" grade_steps.client_account_field"
             
             
            />
            {{ v.name }}


               
              </div>

            </div>
          </div>

          <div class="vx-row mb-6" v-if="selected_campaign.length != 0">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Contact Fields:</span>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Master Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in master_contact_fields"
                :key="index"
              >

              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" grade_steps.master_contact_field"
             
             
            />
            {{ v.name }}


             
              </div>

            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Campaign Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in campaign_contact_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" grade_steps.campaign_contact_field"
             
             
            />
            {{ v.name }}


             
              </div>

            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Client Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in client_contact_fields"
                :key="index"
              >

              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" grade_steps.client_contact_field"
             
             
            />
            {{ v.name }}



               
              </div>

            </div>
          </div>

          <div class="vx-row mb-6" v-if="selected_campaign.length != 0">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Opportunity Fields:</span>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <div
                class="mt-5"
                v-for="(v, index) in opportunity_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" grade_steps.opportunity_field"
             
             
            />
            {{ v.name }}


               
              </div>

            </div>
         
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />

          <DataGrid :context="'GradeSteps'" 
            ref="grade_steps"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      campaign_required: null,
      selected_campaign: [],
      companySearchComponentKey: 0,
      columnDefs: [
        {
          headerName: "Campaign",
          flex: 1,
          field: "campaign_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Step",
          flex: 1,
          field: "step_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          flex: 1,
          field: "step_description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Order",
          field: "order_by",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Fields",
          field: "field",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      campaign_account_fields: [],
      master_account_fields: [],
      client_account_fields: [],
      campaign_contact_fields: [],
      master_contact_fields: [],
      client_contact_fields: [],
      opportunity_fields: [],
      dataSource: {},
      records: [],
      selected: [],
      allGrades: [],
      abilities: null,
      grade_steps: {
        step_name: null,
        step_description: null,
        order_by: 0,
        campaign: [],
        fields: [],
        master_account_field: [],
        client_account_field: [],
        campaign_account_field: [],
        master_contact_field: [],
        client_contact_field: [],
        campaign_contact_field: [],
        opportunity_field: []
      },
      selected_account_fields: [],
      selected_contact_fields: [],
      already_selected_fields: [],
      selected_opportunity_fields:[]
    };
  },
  components: {
    "v-select": vSelect,
    moduleGradeManagement,
    DataGrid,
    CampaignAutocomplete
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule("GradesManagement", moduleGradeManagement);
      moduleGradeManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {},
  watch: {},
  methods: {
    getSelectedAccountFields() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountFields",
          self.selected_campaign
        )
        .then(response => {

          self.master_account_fields = []
          self.campaign_account_fields = []
          self.client_account_fields = []
       


          self.selected_account_fields = JSON.parse(response.data);

          self.selected_account_fields.forEach(function(ele) {
            
            ele.field_from = ele.field_type

            if (ele.field_type == 'master_field' && ele.level == 'account') {
              self.master_account_fields.push(ele);

              self.master_account_fields = self.master_account_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }
            if (ele.field_type == 'client_field' && ele.level == 'account') {
              self.client_account_fields.push(ele);
              self.client_account_fields = self.client_account_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }
            if (ele.field_type == 'campaign_field' && ele.level == 'account') {
              self.campaign_account_fields.push(ele);


              self.campaign_account_fields = self.campaign_account_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }

               //Contact Field

               if (ele.field_type == 'master_field' && ele.level == 'contact') {
              self.master_contact_fields.push(ele);

              self.master_contact_fields = self.master_contact_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }
            if (ele.field_type == 'client_field' && ele.level == 'contact') {
              self.client_contact_fields.push(ele);
              self.client_contact_fields = self.client_contact_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }
            if (ele.field_type == 'campaign_field' && ele.level == 'contact') {
              self.campaign_contact_fields.push(ele);


              self.campaign_contact_fields = self.campaign_contact_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }

          });

      
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSelectedContactFields() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountFields",
          this.selected_campaign
        )
        .then(response => {

          self.master_contact_fields = []
          self.client_contact_fields = []
          self.campaign_contact_fields = []

          self.selected_contact_fields = JSON.parse(response.data);
          console.log("Contact FIELD", self.selected_contact_fields);


          self.selected_contact_fields.forEach(function(ele) {
            ele.field_from = ele.field_type

            if (ele.field_type == 'master_field' && ele.level == 'contact') {
              self.master_contact_fields.push(ele);
              self.master_contact_fields = self.master_contact_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }
            if (ele.field_type == 'client_field' && ele.level == 'contact') {
              self.client_contact_fields.push(ele);
              self.client_contact_fields = self.client_contact_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }
            if (ele.field_type == 'campaign_field' && ele.level == 'contact') {
              self.campaign_contact_fields.push(ele);
              self.campaign_contact_fields = self.campaign_contact_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
            }
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSelectedOpportunityFields() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedOpportunityFields",
          this.selected_campaign
        )
        .then(response => {

          self.opportunity_fields = []

          self.selected_opportunity_fields = JSON.parse(response.data);
          console.log("Opportunity FIELD", self.selected_opportunity_fields);
          self.selected_opportunity_fields.forEach(function(ele) {
            // if (ele["master_field_id"] !== undefined) {
            //   self.master_contact_fields.push(ele);
            //   self.master_contact_fields = self.master_contact_fields.filter(
            //     e => {
            //       return !self.already_selected_fields.some(
            //         item => item.field_id === e.uuid
            //       );
            //     }
            //   );
            // }
            // if (ele["client_field_id"] !== undefined) {
            //   self.client_contact_fields.push(ele);
            //   self.client_contact_fields = self.client_contact_fields.filter(
            //     e => {
            //       return !self.already_selected_fields.some(
            //         item => item.field_id === e.uuid
            //       );
            //     }
            //   );
            // }
              self.opportunity_fields.push(ele);
              self.opportunity_fields = self.opportunity_fields.filter(
                e => {
                  return !self.already_selected_fields.some(
                    item => item.field_id === e.uuid
                  );
                }
              );
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAlreadySelectedFields() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAlreadySelectedFields",
          this.selected_campaign
        )
        .then(response => {
          self.already_selected_fields = response.data;
          console.log("Already Selected FIELD", self.already_selected_fields);

          self.getSelectedAccountFields();
          self.getSelectedContactFields();
          self.getSelectedOpportunityFields();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    // getAllMasterFields() {
    //   this.$store
    //     .dispatch("campaignsManagement/getAllMasterFields")
    //     .then(response => {
    //       this.master_account_fields = response.data;
    //     })
    //     .catch(err => {
    //       if (err.response.status === 404) {
    //         console.log("Error");
    //         return;
    //       }
    //       console.error(err);
    //     });
    // },
    // getPrimaryClientFields() {
    //   let self = this;
    //   let selected_campaign_id = self.selected_campaign.id;
    //   this.$store
    //     .dispatch(
    //       "campaignsManagement/fetchPrimaryClientFields",
    //       selected_campaign_id
    //     )
    //     .then(response => {
    //       this.client_account_fields = response.data;
    //     })
    //     .catch(err => {
    //       if (err.response.status === 404) {
    //         this.campaignDescription = [];
    //         return;
    //       }
    //       console.error(err);
    //     });
    // },
    // getCampaignFields() {
    //   let self = this;
    //   let selected_campaign_id = self.selected_campaign.id;
    //   this.$store
    //     .dispatch(
    //       "campaignsManagement/fetchCampaignFields",
    //       selected_campaign_id
    //     )
    //     .then(response => {
    //       this.campaign_account_fields = response.data;
    //     })
    //     .catch(err => {
    //       if (err.response.status === 404) {
    //         this.campaignDescription = [];
    //         return;
    //       }
    //       console.error(err);
    //     });
    // },
    handleChildEvent() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas;
      self.selected_campaign = result[0];
      self.grade_steps.campaign = self.selected_campaign;

      self.master_account_fields = [];
      self.campaign_account_fields = [];
      self.client_account_fields = [];

      if (self.selected_campaign != null) {
        this.campaign_required = null;
        this.getAlreadySelectedFields();
      }
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("GradesManagement/getAllGradeSteps", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.grade_steps.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.grade_steps.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      if (this.selected_campaign == "") {
        this.campaign_required = "Please select a campaign to proceed.";
        return false;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.addGradeSteps();
        }
      });
    },
    addGradeSteps() {
      let mergedArray = [
        ...this.grade_steps.campaign_account_field,
        ...this.grade_steps.master_account_field,
        ...this.grade_steps.client_account_field,
        ...this.grade_steps.campaign_contact_field,
        ...this.grade_steps.master_contact_field,
        ...this.grade_steps.client_contact_field,
        ...this.grade_steps.opportunity_field
      ];
      this.grade_steps.fields = mergedArray;

      mergedArray.map(function(ele){
        if(ele.client_field_id !== undefined){
          ele.field_from = 'client_field'
        }
        if(ele.master_field_id !== undefined){
          ele.field_from = 'master_field'
        }
        if(ele.campaign_field_id !== undefined){
          ele.field_from = 'campaign_field'
        }
        if(ele.opportunity_field_id !== undefined){
          ele.field_from = 'opportunity_field'
        }

      })
      this.$store
        .dispatch("GradesManagement/addGradeSteps", this.grade_steps)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Grades Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Grades Added",
              text: "The grade_steps was added successfully"
            });
            this.$router.go(0);
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
